import axios from 'axios';

export const logsService = new class LogsService {

  getLogs(rawParams) {
    const params = {
      qUserId: rawParams.qUserId || undefined,
      qAction: rawParams.qAction || undefined,
      qData: rawParams.qData || undefined,
      sortOrder: rawParams.sortOrder || undefined,
      orderBy: rawParams.orderBy || undefined,
      offset: rawParams.offset || 0,
      pageSize: rawParams.pageSize || 10,
    };
    return axios.get('/api/logs', { params })
      .then(response => response);
  }
};